import React from 'react'
import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {cssTheme} from '@vio/atlas/themes'

const NameWrapper = styled.div`
  ${cssTheme.typography.bodyXS}
`

interface Props {
  place: string
  hotelId: string
  hidePinIcon?: boolean
}

export const Location = ({place, hotelId, hidePinIcon = false}: Props) => {
  return (
    <Box
      display="flex"
      color="content.neutral.secondary"
      alignItems="flex-start"
      justifyContent="flex-start"
    >
      {!hidePinIcon && <Icon name="Pin" size="sm" />}
      <NameWrapper id={`HotelCardMobileLocation-${hotelId}`} data-id="Location">
        {place}
      </NameWrapper>
    </Box>
  )
}
